module.exports = __webpack_public_path__ + "static/media/boy.8b2b0bba.png";